import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';

const loaderTypes = {
    linear: className => <LinearProgress className={ className } />,
    circular: className => <CircularProgress className={ className } />,
};

const Loader = ({ text = '', type = 'linear', theme }) => (
    <div className={ theme.loaderContainer }>
        { text && <p className={ theme.text }>{ text }</p> }
        { loaderTypes[type](theme.loader) }
    </div>
);

Loader.propTypes = {
    text: PropTypes.string,
    type: PropTypes.oneOf(Object.keys(loaderTypes)),
    theme: PropTypes.shape({}),
};

export default Loader;
